<template>
  <el-dialog
    title=""
    :visible="true"
    :show-close="false"
    width="900px"
    center
    class="ts-modal"
  >
    <button
      type="button"
      aria-label="Close"
      class="el-dialog__headerbtn"
      @click="onCloseDialog(null)"
    >
      <i class="el-dialog__close el-icon el-icon-close"></i>
    </button>

    <h6 style="text-align: left;">History of Role Matches & Applications</h6>
    <p style="text-align: left;">
      Below is a table filled with all the past vacant roles that you were
      matched with based on your Skills Profile as well as the ones that you
      applied for.
    </p>

    <el-table
      :default-sort="{ prop: 'Date', order: 'descending' }"
      :data="tableData"
      style="width: 100%; height: 400px; overflow-y: scroll"
    >
      <el-table-column prop="date" label="Date" width="130" sortable>
        <template slot-scope="scope">
          {{ scope.row.date | moment("MM/DD/YYYY") }}
        </template>
      </el-table-column>
      <el-table-column prop="roleTitle" label="Role Title" width="150" sortable>
        <template slot-scope="scope">
          <span style="word-break: normal">{{ scope.row.roleTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="company" label="Company Name" width="180" sortable>
      </el-table-column>
      <el-table-column
        label="Percentage Match"
        prop="percentageMatch"
        width="170"
        sortable
      >
        <template scope="scope">
          <div style="margin-left: 30px;">
            <span
              v-if="
                Math.floor(scope.row.percentageMatch) >= 0 &&
                  Math.floor(scope.row.percentageMatch) <= 10
              "
              class="dot-quarter"
              >{{ Math.floor(scope.row.percentageMatch) }}%</span
            >
            <span
              v-if="
                Math.floor(scope.row.percentageMatch) >= 11 &&
                  Math.floor(scope.row.percentageMatch) <= 30
              "
              class="dot-half"
              >{{ Math.floor(scope.row.percentageMatch) }}%</span
            >
            <span
              v-if="
                Math.floor(scope.row.percentageMatch) >= 31 &&
                  Math.floor(scope.row.percentageMatch) <= 69
              "
              class="dot-third"
              >{{ Math.floor(scope.row.percentageMatch) }}%</span
            >
            <span
              v-if="
                Math.floor(scope.row.percentageMatch) >= 70 &&
                  Math.floor(scope.row.percentageMatch) <= 100
              "
              class="dot-whole"
              >{{ Math.floor(scope.row.percentageMatch) }}%</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="appliedFor" label="Applied For" width="80">
        <template scope="scope">
          <el-tag
            v-if="scope.row.appliedFor == true"
            type="success"
            effect="plain"
          >
            Yes
          </el-tag>
          <el-tag v-else type="danger" effect="plain">
            No
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="approachedByCompany"
        label="Approached by Company"
        width="100"
      >
        <template scope="scope">
          <el-tag
            v-if="scope.row.approachedByCompany == true"
            type="success"
            effect="plain"
          >
            Yes
          </el-tag>
          <el-tag v-else type="danger" effect="plain">
            No
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <div class="ts-modal_actions">
      <button
        class="ts-btn ts-btn-white ts-btn-small"
        @click="onCloseDialog(null)"
      >
        Close
      </button>
    </div>

    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </el-dialog>
</template>

<script>
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: { TSLoading },
  created() {
    this.loading = true;
    this.$store
      .dispatch("jobseeker/getMyApplications")
      .then(res => {
        this.tableData = res;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  data() {
    return {
      csvModelState: null,
      tableData: [],
      loading: false
    };
  },
  methods: {
    onCloseDialog(done) {
      this.$router.go(-1);
    }
  }
};
</script>
